import { useMemo } from 'react';
import { useHttpClient } from '@wix/cli-http-client-react';
import { usePanoramaMethodLogger } from '@wix/cli-panorama';
import { MetasiteManagerClient } from './metasite-manager-client.js';

export function useMetasiteManagerClient({
  siteId,
}: {
  siteId?: string;
} = {}): MetasiteManagerClient {
  const httpClient = useHttpClient({ type: 'general', siteId });
  const client = useMemo(
    () => new MetasiteManagerClient(httpClient),
    [httpClient]
  );

  return usePanoramaMethodLogger(client);
}
